class MFRStickyOffset {
    constructor( index, element ) {
        this.$element = $( element );
        if( !this.$element.attr( "data-mfr-offset-top" ) ) return;
        this.offset = this.$element.attr( "data-mfr-offset-top" ).replace( "%", "" ) / 100;

        $( window )
            .on( "resize", this.init.bind( this ) )
        this.init();
        setTimeout( () => $( window ).trigger( "resize" ), 800 );
    }

    init() {
        const wrapper = $( this.$element.attr( "data-scroll-target" ) );
        const offsetBase = ( ( $( window ).height() - $( "header.header" ).height() ) * this.offset ) - ( this.$element.height() * this.offset ) + $( "header.header" ).height();
        const topOffset = ( offsetBase * -1 ) + parseInt( wrapper.css( "padding-top" ).replace( "px", "" ) );
        const bottomOffset = offsetBase + parseInt( wrapper.css( "padding-bottom" ).replace( "px", "" ) );
        this.$element
            .attr( "data-scroll-offset", `${ parseInt( topOffset.toFixed(0) ) + parseInt( this.$element.css( "margin-top" ).replace( "px", "" ) ) },${bottomOffset.toFixed(0)}` );

        window.mfrScroll.update();
    }
}